<template>
  <b-container fluid>
    <div class="pt-5 header">
      <img
        class="brand-icon pointer"
        src="../assets/smartz-logo.svg"
        @click="toDashboard()"
      />
      <b-navbar toggleable="sm">
        <b-nav class="nav-wrapper">
          <b-nav-item
            to="/"
            :active="activeIndex === '/'"
            v-if="
              p('Dashboard.Pod Accel.View') ||
                p('Dashboard.Pod Capacitance.View') ||
                p('Dashboard.Pod Data Stream.View')
            "
          >
            <img
              class="mr-5"
              v-if="activeIndex === '/'"
              src="../assets/dashboard-active.svg"
            />
            <img class="mr-5" v-else src="../assets/dashboard-default.svg" />
            {{ $t('text.dashboard') }}</b-nav-item
          >
          <b-nav-item
            to="/products"
            :active="activeIndex === '/products'"
            v-if="
              p('Products.Manufacturers.View') ||
                p('Products.Product Description.View') ||
                p('Products.Product Characteristics.View') ||
                p('Products.Run.View') ||
                p('Products.Analyse Runs.View')
            "
          >
            <img
              class="w-20 mr-5"
              v-if="activeIndex === '/products'"
              src="../assets/chart-active.svg"
            />
            <img class="w-20 mr-5" v-else src="../assets/chart-default.svg" />
            {{ $t('text.products') }}</b-nav-item
          >
          <b-nav-item
            to="/pods"
            :active="activeIndex === '/pods'"
            v-if="
              p('Pods.Capacitance Readings Chart.View') ||
                p('Pods.Connection Status Chart.View') ||
                p('Pods.Battery Levels Chart.View') ||
                p('Pods.Accelerometer Readings Chart.View') ||
                p('Pods.Temperature Chart.View') ||
                p('Pods.SPO2 Chart.View') ||
                p('Pods.Calibration.View') ||
                p('Pods.Find Data.View') ||
                p('Pods.Diagnostics.View') ||
                p('Pods.Live Data.View')
            "
          >
            <img
              class="w-12 mr-5"
              v-if="activeIndex === '/pods'"
              src="../assets/goal-active.svg"
            />
            <img class="w-12 mr-5" v-else src="../assets/goal-default.svg" />
            {{ $t('text.pods') }}</b-nav-item
          >
          <b-nav-item
            to="/reports"
            :active="activeIndex === '/reports'"
            v-if="p('Reports.Export CSV.Export')"
          >
            <img
              class="w-15 mr-5"
              v-if="activeIndex === '/reports'"
              src="../assets/report-active.svg"
            />
            <img class="mr-5" v-else src="../assets/report-default.svg" />
            {{ $t('text.reports') }}</b-nav-item
          >
          <b-nav-item
            to="/production"
            :active="activeIndex === '/production'"
            v-if="
              p('Production.Monitoring.View') ||
                p('Production.Test Reports.View') ||
                p('Production.Acceptance Criteria.View') ||
                p('Production.Firmware & Software.View')
            "
          >
            <img
              class="w-15 mr-5"
              v-if="activeIndex === '/production'"
              src="../assets/production-active.svg"
            />
            <img class="mr-5" v-else src="../assets/production-default.svg" />
            PRODUCTION</b-nav-item
          >
          <b-nav-item
            to="/manage"
            :active="activeIndex === '/manage'"
            v-if="
              p('Manage.Users.View') ||
                p('Manage.Roles.View') ||
                p('Manage.Distributors.View')
            "
          >
            <img
              class="w-15 mr-5"
              v-if="activeIndex === '/manage'"
              src="../assets/manage-active.svg"
            />
            <img class="mr-5" v-else src="../assets/manage-default.svg" />
            {{ $t('text.manage').toUpperCase() }}</b-nav-item
          >
          <b-nav-item
            to="/backtest"
            :active="activeIndex === '/backtest'"
            v-if="p('BackTest.View')"
          >
            <img
              class="w-15 mr-5"
              v-if="activeIndex === '/backtest'"
              src="../assets/chart-active.svg"
            />
            <img class="w-20 mr-5" v-else src="../assets/chart-default.svg" />
            BACKTEST</b-nav-item
          >
        </b-nav>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <!-- <LanguageBar /> -->
            <img
              src="../assets/helper.svg"
              class="helper-icon pointer"
              id="helper"
            />
            <b-popover
              target="helper"
              triggers="click"
              custom-class="helper-content"
              placement="bottomleft"
              @show="showPopover()"
            >
              <template v-slot:title>{{ helper.title.toUpperCase() }}</template>
              <div v-html="helper.content"></div>
            </b-popover>
            <b-nav-item-dropdown class="user-dropdown" right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <!-- <em>{{ Username }}</em> -->
                <img
                  class="right-float mr-30 user-icon"
                  src="../assets/user-black.svg"
                />
              </template>
              <b-dropdown-item
                @click="redirectTo('https://www.smartzhealth.com/faqs/')"
                >{{ $t('text.frequently_asked_questions') }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="redirectTo('https://www.smartzhealth.com/user-manual/')"
                >{{ $t('text.information_for_use') }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="redirectTo('https://smartzhealth.com/downloads/')"
                >{{ $t('text.data_privacy') }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="redirectTo('https://smartzhealth.com/downloads/')"
                >{{ $t('text.eula') }}</b-dropdown-item
              >
              <b-dropdown-item v-b-modal.about>{{
                $t('text.about')
              }}</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item>Settings</b-dropdown-item>
              <b-dropdown-item @click="logout">
                {{ $t('text.logout') }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <b-modal
      id="about"
      ref="about"
      centered
      :hide-header="true"
      :hide-footer="true"
    >
      <div class="white-bg">
        <img
          src="../assets/brand_logo_black.png"
          width="150px"
          class="mb-10 mt-30"
        />
        <div class="name mb-5">{{ $t('text.dashboard') }}</div>
        <div class="version mb-30">{{ $t('text.version') }} {{ version }}</div>
      </div>
      <div class="grey-bg">
        <div class="inline-block left-side">
          <div class="mb-40">{{ $t('text.copyright') }}.</div>
          <div class="mb-5">{{ $t('text.support').toUpperCase() }}</div>
          <div>customerservice@simavita.com</div>
        </div>
        <div class="inline-block right-float text-right">
          <img src="../assets/c1.svg" class="mr-10" />
          <img src="../assets/c2.svg" />
          <div class="close-btn">
            <b-button variant="outline-primary" @click="closeAboutModal()">{{
              $t('text.close')
            }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
// import LanguageBar from '@/components/LanguageBar.vue'
export default {
  data() {
    return {
      activeIndex: this.$route.path,
      helper: {
        title: '',
        content: ''
      },
      version: ''
    }
  },
  // components: {
  //   LanguageBar
  // },
  mounted() {
    let app = require('../../package.json')
    this.version = app.version
  },
  methods: {
    toDashboard() {
      this.$router.push('/')
      this.$parent.$refs.content.type = 'pod_capacitance'
    },
    logout() {
      localStorage.removeItem('user')
      this.$router.push({ path: '/login' })
    },
    closeAboutModal() {
      this.$refs['about'].hide()
    },
    redirectTo(link) {
      window.open(link, '_blank')
    },
    showPopover() {}
  },
  computed: {
    Username() {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user != null) {
        return user.username
      }
      return null
    }
  }
}
</script>
